<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
  <p>{{message}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
